import { headerTrackingActionTemplate } from '../../features/header/trackingActions';

export function logoTrackingAction(eventLabel) {
  return headerTrackingActionTemplate('Logo', eventLabel);
}
